<template>
  <DiagramBlock
    title="Cashback withdrawal"
    emptyDesc="There is no cashback statistics data available yet"
    :diagramItems="statistic"
    :loading="loading"
    @details="clickToDetails"
    @legendClick="legendClick"
    @chartClick="chartClick"
  />
</template>

<script>
import apiClient from '@/services/axios'
import DiagramBlock from '@/views/apps/referral-program/referral-programs/components/DiagramBlock'
import { getCashbackStatusColors } from '@/views/apps/referral-program/referral-programs/composables/useGetCashbackStatusColors'
import { getErrorMessage } from '@/views/apps/fortune-wheel/composables/useGetErrorMessage.js'

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL

export default {
  components: {
    DiagramBlock,
  },
  data: () => ({
    programId: null,
    statistic: [],
    loading: true,
  }),
  methods: {
    clickToDetails() {
      this.$router.push(`/referral/programs/${this.programId}/cashback-withdrawal`)
    },
    legendClick(param) {
      this.$router.push(`/referral/programs/${this.programId}/cashback-withdrawal?status=${param}`)
    },
    chartClick({ name }) {
      this.$router.push(`/referral/programs/${this.programId}/cashback-withdrawal?status=${name}`)
    },
    getColor(status) {
      return getCashbackStatusColors(status)
    },
    setStatistic(items) {
      if (!items?.length) {
        return
      }
      this.statistic = items.map(item => {
        return {
          name: item.name,
          value: item.value,
          items: item.items,
          itemStyle: { color: this.getColor(item.name) },
        }
      })
    },
    async getMembersStatistics() {
      this.programId = this.$route.params.id
      try {
        this.loading = true
        const url = `${referralApiUrl}/referral-programs/${this.programId}/cashback/statistic`
        const response = await apiClient.get(url)
        const { data } = response?.data
        if (data) {
          this.setStatistic(data)
          return
        }
        getErrorMessage(response?.data)
      } catch (e) {
        this.$notification.error({
          message: e?.message ? e.message : 'Error',
        })
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.getMembersStatistics()
  },
}
</script>
